/** Mirrors product-subscription's `UserSubscription.billedBy`, a plain string on the wire. */
export const BilledBy = {
  Waipu: 'WAIPU',
  AppleIap: 'APPLE_IAP',
  GoogleIap: 'GOOGLE_IAP',
  AmazonIap: 'AMAZON_IAP',
  RokuIap: 'ROKU_IAP',
  Epay: 'EPAY',
  B2bPartner: 'B2B_PARTNER',
} as const;

export type ExternalBillingProvider = 'apple' | 'google' | 'amazon' | 'roku' | 'partner';

export type ExternalBilling = {
  provider: ExternalBillingProvider;
  /** Absent for resellers: no self-service page to link to. */
  href?: string;
};

const iapStores: Record<string, ExternalBilling> = {
  [BilledBy.AppleIap]: { provider: 'apple', href: 'https://apps.apple.com/account/subscriptions' },
  [BilledBy.GoogleIap]: { provider: 'google', href: 'https://play.google.com/store/account/subscriptions' },
  [BilledBy.AmazonIap]: { provider: 'amazon', href: 'https://www.amazon.de/gp/mas/your-account/myapps/yoursubscriptions' },
  [BilledBy.RokuIap]: { provider: 'roku', href: 'https://my.roku.com/' },
};

export function getExternalBilling(billedBy: string | undefined): ExternalBilling | null {
  if (!billedBy || billedBy === BilledBy.Waipu) {
    return null;
  }
  return iapStores[billedBy] ?? { provider: 'partner' };
}
